/* WhataHoot: sends the theme's existing enquiry forms (the "WH …" sections,
   which are Shopify contact forms) to the Events app instead of as emails.
   The forms keep their look and questions. Which kind of enquiry each form is
   comes from its hidden "Enquiry type" field. If the Events app can't be
   reached, the form is sent the old way (Shopify contact email), so an
   enquiry is never lost.

   Loaded on every page from snippets/wah-age-gate.liquid. Only forms listed
   in FORMS below are taken over; every other form is left alone.
   Change the app address with window.WAH_EVENTS_APP, or edit APP below. */
(function () {
  'use strict';
  var APP = 'https://whatahoot-events-management.vercel.app';

  // Hidden "Enquiry type" value (exact, as in the WH … sections) -> how the Events app should treat it.
  var FORMS = [
    [/^Private celebration or group experience$/i, function (f) {
      return { type: /venue hire|food and drinks/i.test(f['Preferred experience'] || '') ? 'hire' : 'private_experience', booking: true, occasion: f.Occasion };
    }],
    [/^Corporate experience or team event$/i, function (f) {
      return { type: /venue hire/i.test(f['Preferred experience'] || '') ? 'hire' : 'private_experience', booking: true, occasion: f['Event reason'] ? 'Corporate: ' + f['Event reason'] : 'Corporate event' };
    }],
    [/^Wedding products, favours or experiences$/i, function (f) {
      // Only hen/stag and pre-wedding events are bookings here; the date on
      // this form is their wedding day, usually somewhere else, so it's a detail.
      return { type: 'wedding', booking: /hen or stag|pre-wedding/i.test(f['Wedding interest'] || ''), occasion: f['Wedding interest'] || 'Wedding', noDates: true };
    }],
    [/^Host or produce an event at WhataHoot$/i, function (f) {
      return { type: 'other', booking: false, occasion: f['Event concept'] || f['Event type'] || 'Event proposal', noDates: true };
    }],
    [/^Trade and wholesale account$/i, function () { return { type: 'trade' }; }],
    [/^Corporate gifting or white label$/i, function (f) { return { type: 'trade', businessType: f['Project type'] ? 'Corporate gifting: ' + f['Project type'] : 'Corporate gifting' }; }],
  ];

  var PICK = {
    preferred_date: ['Preferred event date', 'Preferred date'],
    alternative_date: ['Alternative event date', 'Alternative date'],
    guests: ['Group size', 'Guest count', 'Expected attendance', 'Number of guests'],
    company: ['Company name', 'Business name', 'Business or act name', 'Company'],
    budget: ['Estimated budget per person', 'Budget'],
    business_type: ['Business type'],
    business_website: ['Website'],
  };
  var SKIP = ['Enquiry type', 'Source page', 'Submitted at', 'Privacy consent', 'Company website confirmation'];

  // contact[...] fields -> the Events app's enquiry (pure, so it can be tested).
  function toEnquiry(fields, typeLabel) {
    var rule = null;
    for (var i = 0; i < FORMS.length; i += 1) if (FORMS[i][0].test(String(typeLabel || '').trim())) { rule = FORMS[i][1]; break; }
    if (!rule) return null;
    var how = rule(fields);
    var out = {
      enquiry_type: how.type, booking: how.booking !== false,
      name: fields.name, email: fields.email, phone: fields.phone, message: fields.body,
      source_page: fields['Source page'], url_confirm: fields['Company website confirmation'], details: {},
    };
    var used = { name: 1, email: 1, phone: 1, body: 1 };
    SKIP.forEach(function (k) { used[k] = 1; });
    Object.keys(PICK).forEach(function (key) {
      if ((key === 'preferred_date' || key === 'alternative_date') && how.noDates) return;
      var label = PICK[key].filter(function (l) { return fields[l]; })[0];
      if (!label) return;
      out[key] = fields[label];
      used[label] = 1;
    });
    if (how.businessType && !out.business_type) out.business_type = how.businessType;
    Object.keys(fields).forEach(function (k) { if (!used[k] && fields[k]) out.details[k] = fields[k]; });
    if (how.occasion) out.details.Occasion = how.occasion;
    out.details.Form = typeLabel;
    return out;
  }

  function uid() {
    return (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2);
  }

  function readFields(form) {
    var fields = {};
    new FormData(form).forEach(function (value, key) {
      var m = /^contact\[(.+)\]$/.exec(key);
      var v = String(value).trim();
      if (m && v) fields[m[1]] = v;
    });
    return fields;
  }

  function notice(form, html, isError) {
    var old = form.querySelector('[data-wah-app-notice]');
    if (old) old.remove();
    var box = document.createElement('div');
    box.className = 'wah-enquiry__notice';
    box.setAttribute('data-wah-app-notice', '');
    box.setAttribute('role', isError ? 'alert' : 'status');
    box.tabIndex = -1;
    box.innerHTML = html;
    var grid = form.querySelector('.wah-enquiry__grid');
    (grid ? grid.parentNode : form).insertBefore(box, grid || form.firstChild);
    box.focus();
    return box;
  }

  function sendTheOldWay(form) {
    form.setAttribute('data-wah-app-off', '1');
    HTMLFormElement.prototype.submit.call(form);
  }

  function setup(form) {
    if (form.getAttribute('data-wah-app-ready')) return;
    var typeInput = form.querySelector('input[name="contact[Enquiry type]"]');
    if (!typeInput || !toEnquiry({}, typeInput.value)) return; // not one of ours
    form.setAttribute('data-wah-app-ready', '1');
    var startedAt = Date.now();
    var submissionId = uid();
    var endpoint = String(window.WAH_EVENTS_APP || APP).replace(/\/+$/, '') + '/api/enquiry';

    form.addEventListener('submit', function (ev) {
      if (form.getAttribute('data-wah-app-off')) return; // falling back to Shopify's email
      ev.preventDefault();
      var payload = toEnquiry(readFields(form), typeInput.value);
      payload.submission_id = submissionId;
      payload.started_at = startedAt;
      var button = form.querySelector('[type=submit]');
      var label = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'Sending…'; }
      var controller = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { if (controller) controller.abort(); }, 15000);

      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: controller ? controller.signal : undefined })
        .then(function (res) {
          clearTimeout(timer);
          return res.json().catch(function () { return {}; }).then(function (body) { return { res: res, body: body }; });
        })
        .then(function (r) {
          if (r.res.ok) {
            var ref = r.body.reference ? ' Your reference is <strong>' + String(r.body.reference).replace(/[^A-Z0-9-]/gi, '') + '</strong>.' : '';
            var text = payload.enquiry_type === 'trade'
              ? 'Thank you, our trade team has your enquiry and will be in touch.'
              : payload.booking
                ? 'Thank you, we’ve got your enquiry and emailed you what happens next.'
                : 'Thank you, we’ve got your enquiry and will be in touch soon.';
            var grid = form.querySelector('.wah-enquiry__grid');
            if (grid) grid.hidden = true;
            notice(form, '<strong>' + text + '</strong>' + ref);
            submissionId = uid();
            return;
          }
          if (r.res.status >= 400 && r.res.status < 500 && r.res.status !== 404) {
            // Something the customer can fix (e.g. an email address that doesn't look right).
            notice(form, '<strong>' + String(r.body.error || 'Please check the form and try again.').replace(/[<>&]/g, '') + '</strong>', true);
            if (button) { button.disabled = false; button.textContent = label; }
            return;
          }
          sendTheOldWay(form);
        })
        .catch(function () { clearTimeout(timer); sendTheOldWay(form); });
    });
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('form'), setup);
  }
  window.WahAppEnquiry = { toEnquiry: toEnquiry };
  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (ev) { init(ev.target); });
})();
